<apiz-toolbar
  class="iu-apiz-toolbar"
  [filterTplRef]="universalFilter"
  [showFilterTitle]="false"
  [ngStyle]="{ display: hasUniversalFilter ? '' : 'none' }">
  <div azProjectAs="toolbar-container-left" class="iu-apiz-toolbar-group-left">
    @if (isMobile && isTabTopLevel) {
      <button
        class="p-menu-bar-button"
        data-cy="menuBar-showButtons-btn"
        icon="icon-menu-bars"
        pButton
        tooltipPosition="top"
        type="button"
        [attr.aria-expanded]="showMoreAction"
        [attr.aria-label]="'menuBarDetails.showButtons' | translate"
        [attr.data-cy-toggle-state]="showMoreAction ? 'opened' : 'closed'"
        [hideDelay]="250"
        [life]="3000"
        pTooltip="{{ 'menuBarDetails.showButtons' | translate }}"
        [showDelay]="250"
        (click)="onShowMoreAction($event)">
        {{ '' }}
      </button>

      @if (showMoreAction) {
        <ng-container [ngTemplateOutlet]="buttons" />

        <ng-container [ngTemplateOutlet]="viewButtons" />
      }
    } @else if (!isMobile || !isTabTopLevel) {
      <ng-container [ngTemplateOutlet]="buttons" />
    }
  </div>

  <div azProjectAs="toolbar-container-right" class="iu-apiz-toolbar-group-right">
    @if (filterCount() > 1) {
      <!-- several filters: clear them in one click -->
      <button
        type="button"
        class="iu-clear-filters-btn"
        data-cy="grid-btn-clear-filters"
        [attr.aria-label]="'menuBarUi.clearFilters' | translate"
        (click)="clearFilters()">
        <i class="icon-close" aria-hidden="true"></i>
        <span>{{ 'menuBarUi.clearFilters' | translate }}</span>
      </button>
    }
    <iu-favorite-filter [gridView]="gridView" />
    @if (visibleButton && (!isMobile || !isTabTopLevel)) {
      <ng-container [ngTemplateOutlet]="viewButtons" />
    }
  </div>
</apiz-toolbar>

<ng-template #universalFilter>
  <iu-universal-filter-ui [gridView]="gridView" [isMobile]="isMobile" />
</ng-template>

<ng-template #buttons>
  @if (visibleButton) {
    <button
      class="p-menu-bar-button"
      data-cy="button-newRecord"
      icon="icon-add"
      iuKeybinding
      iuKeybinding-code="menu-bar.new"
      pButton
      tooltipPosition="right"
      type="button"
      [disabled]="!newBtnCondition"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.add }}"
      [attr.aria-label]="tooltipLabels.add"
      [showDelay]="250"
      (click)="newEmitter.emit()">
      {{ '' }}
    </button>

    @if (visibleButtonMultiSelection && isDeleteable && (isReadOnly === undefined || isReadOnly === false)) {
      <button
        class="p-menu-bar-button p-menu-bar-button-danger"
        icon="icon-delete"
        iuKeybinding
        iuKeybinding-code="menu-bar.delete"
        pButton
        tooltipPosition="top"
        type="button"
        [hideDelay]="250"
        [iuKeybinding-active]="isTabTopLevel && !isSplitView"
        [iuKeybinding-focusTab]="activeTabID"
        [life]="3000"
        pTooltip="{{ tooltipLabels.delete }}"
        [attr.aria-label]="tooltipLabels.delete"
        [showDelay]="250"
        (click)="removeEmitter.emit($event)">
        {{ '' }}
      </button>
    }
  }

  <button
    class="p-menu-bar-button"
    data-cy="grid-btn-refresh"
    icon="icon-refresh3x"
    iuKeybinding
    iuKeybinding-code="menu-bar.refresh"
    pButton
    tooltipPosition="top"
    type="button"
    [hideDelay]="250"
    [iuKeybinding-active]="isTabTopLevel && !isSplitView"
    [iuKeybinding-focusTab]="activeTabID"
    [life]="3000"
    pTooltip="{{ tooltipLabels.refresh }}"
    [attr.aria-label]="tooltipLabels.refresh"
    [showDelay]="250"
    (click)="refreshEmitter.emit()">
    {{ '' }}
  </button>
  @if (visibleButton) {
    <button
      class="p-menu-bar-button"
      icon="icon-export"
      iuKeybinding
      iuKeybinding-code="menu-bar.export"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.export }}"
      [attr.aria-label]="tooltipLabels.export"
      [showDelay]="250"
      (click)="openExportDataModalEmitter.emit($event)">
      {{ '' }}
    </button>
  }
  @if (visibleButton && visibleButtonMultiSelection && processes().length) {
    <!-- opens on click (keyboard and touch), Escape or a click outside closes it -->
    <ul class="hover-buttons-list" [class.is-open]="processMenuOpen()" (keydown.escape)="closeProcessMenu(true)">
      <li>
        <button
          #processMenuTrigger
          type="button"
          class="open-icon-title"
          aria-haspopup="menu"
          [attr.aria-expanded]="processMenuOpen()"
          (click)="toggleProcessMenu($event)">
          <span>{{ 'menuBarUi.processes' | translate }}</span>
          <i aria-hidden="true" class="icon-next-ancre"></i>
        </button>
        @if (processMenuOpen()) {
          <ul class="hover-buttons" role="menu" [attr.aria-busy]="processChecking() || null">
            @if (processChecking()) {
              <li role="none" class="hover-buttons-status">{{ 'menuBarUi.processChecking' | translate }}</li>
            }
            @for (process of processes(); track $index) {
              @if (!isProcessHidden(process)) {
                @let blocked = isProcessBlocked(process);
                <li role="none">
                  <button
                    type="button"
                    role="menuitem"
                    class="hover-button"
                    [class.readonly]="blocked"
                    [attr.aria-disabled]="blocked || null"
                    [title]="processTitle(process)"
                    (click)="runProcess(process)">
                    <span>{{ process.label }}</span>
                    <i aria-hidden="true" class="fas fa-cog"></i>
                  </button>
                </li>
              }
            }
            @if (allProcessesHidden()) {
              <li role="none" class="hover-buttons-status">{{ 'menuBarUi.noProcess' | translate }}</li>
            }
          </ul>
        }
      </li>
    </ul>
  }
</ng-template>

<ng-template #viewButtons>
  @if (isTabTopLevel || visibleTreeButton) {
    <button
      class="p-menu-bar-button"
      icon="icon-table"
      iuKeybinding
      iuKeybinding-code="menu-bar.grid-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.gridView }}"
      [attr.aria-label]="tooltipLabels.gridView"
      [attr.aria-pressed]="gridView?.viewType === 'grid'"
      [class.p-menu-bar-button-active]="gridView?.viewType === 'grid'"
      [showDelay]="250"
      (click)="switchToGridView()">
      {{ '' }}
    </button>
  }
  @if (isTabTopLevel) {
    <button
      class="p-menu-bar-button"
      icon="icon-kanban"
      iuKeybinding
      iuKeybinding-code="menu-bar.kanban-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.kanbanView }}"
      [attr.aria-label]="tooltipLabels.kanbanView"
      [attr.aria-pressed]="gridView?.viewType === 'kanban'"
      [class.p-menu-bar-button-active]="gridView?.viewType === 'kanban'"
      [showDelay]="250"
      (click)="switchToKanbanView()">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      icon="icon-calendar"
      iuKeybinding
      iuKeybinding-code="menu-bar.calendar-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.calendarView }}"
      [attr.aria-label]="tooltipLabels.calendarView"
      [attr.aria-pressed]="gridView?.viewType === 'calendar'"
      [class.p-menu-bar-button-active]="gridView?.viewType === 'calendar'"
      [showDelay]="250"
      (click)="switchToCalendarView()">
      {{ '' }}
    </button>
    <button
      class="p-menu-bar-button"
      icon="icon-graph-smart"
      iuKeybinding
      iuKeybinding-code="menu-bar.chart-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.chartView }}"
      [attr.aria-label]="tooltipLabels.chartView"
      [attr.aria-pressed]="gridView?.viewType === 'chart'"
      [class.p-menu-bar-button-active]="gridView?.viewType === 'chart'"
      [showDelay]="250"
      (click)="switchToChartView()">
      {{ '' }}
    </button>
  }
  @if (visibleTreeButton) {
    <button
      class="p-menu-bar-button"
      data-cy="menuBar-tree-view-type-btn"
      icon="icon-tree"
      iuKeybinding
      iuKeybinding-code="menu-bar.tree-view-type"
      pButton
      tooltipPosition="top"
      type="button"
      [hideDelay]="250"
      [iuKeybinding-active]="isTabTopLevel && !isSplitView"
      [iuKeybinding-focusTab]="activeTabID"
      [life]="3000"
      pTooltip="{{ tooltipLabels.treeView }}"
      [attr.aria-label]="tooltipLabels.treeView"
      [attr.aria-pressed]="gridView?.viewType === 'tree'"
      [class.p-menu-bar-button-active]="gridView?.viewType === 'tree'"
      [showDelay]="250"
      (click)="switchToTreeView()">
      {{ '' }}
    </button>
  }
</ng-template>

<!--
@if (displayProcessUI()) {
  <iu-modal-ui
    [angularStyle]="{ 'iu-modal-body': { padding: 0 } }"
    [contentType]="ModalContentType.PROCESS"
    [hasCloseBtn]="true"
    (closeModalEmitter)="hideProcessUI()">
    <iu-process-ui
      [isModal]="true"
      [parentComponent]="this"
      [windowId]="processId"
      [executeProcess]=""
      (closeModalEmitter)="hideProcessUI()" />
  </iu-modal-ui>
}
-->
